import React, { useContext } from 'react';
import styles from './CargandoInicio.module.css';
import imgLoaderGeneral from '../../img/2.gif';
import GeneralContext from '../../context/GeneralContext';

const CargandoInicio = () => {
  const { state: generalState } = useContext(GeneralContext)

  return (
    <React.Fragment>
      {generalState.estadoCargando
        ? <div className={styles['modal']}>
          <div className={styles['modal-content']}>
            <img src={imgLoaderGeneral} alt='Cargando' />
          </div>
        </div>
        : null
      }
    </React.Fragment>
  )
}

export default CargandoInicio;